import { popupStore } from '@pascal/pascal-core';
import { gameLiveConnection } from '../services';

class LiveConnection {
  isConnected = false;

  handleSocketInit() {
    gameLiveConnection
      ?.init()
      .then(() => {
        this.isConnected = true;
        this.connectionInitCallback();
      })
      .catch(() => popupStore.onConnectionError(true));
  }

  restartGameConnection() {
    return new Promise((res) => {
      gameLiveConnection.stop().then(() => {
        gameLiveConnection.init().then(() => {
          this.connectionInitCallback();
          res();
        });
      });
    });
  }

  connectionInitCallback(bool) {
    if (this.isConnected) {
      gameLiveConnection.sendGameGetInitialState(bool).then(() => {});
    }
  }
}

export const liveConnection = new LiveConnection();
